import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef } from 'react';
import { ThemeProvider } from 'react-jss';
import { ReactNotifications } from 'react-notifications-component';
import { useEffectOnce, useFullscreen } from 'react-use';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { TourProvider } from '@reactour/tour';
import ThemeContext from '../contexts/themeContext';

import Aside from '../layout/Aside/Aside';
import Wrapper from '../layout/Wrapper/Wrapper';
import Portal from '../layout/Portal/Portal';
import { demoPages, homeMenu, layoutMenu } from '../menu';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import useDarkMode from '../hooks/useDarkMode';
import COLORS from '../common/data/enumColors';
import { getOS } from '../helpers/helpers';
import steps, { styles } from '../steps';
import { Provider, rootStore, useMst } from '../models';
import { getItem, removeItem } from '../lib/localstorage';
import { observer } from 'mobx-react';
import config from '../config';

let interval = null
const App = observer(() => {

	const location = useLocation();
	const navigate = useNavigate();
	const { user } = useMst();
	getOS();

	/**
	 * Dark Mode
	 */
	const { themeStatus, darkModeStatus } = useDarkMode();
	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};

	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	/**
	 * Full Screen
	 */
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	/**
	 * Modern Design
	 */
	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	// useEffect(() => {
	// 	if(withOutAsidePages.findIndex(v => '/' + v === location.pathname) === -1) {
	// 		user.authMe();
	// 	}
	// 	//eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [location])

	useEffect(() => {
		
		if(withOutAsidePages.findIndex(v => '/' + v === location.pathname) === -1) {
			console.log('page start');
			user.authMe();

			if (user.me.id > 0 && user.me.status === 'SUCCESS_WAIT') {					
				removeItem('access-token')
				removeItem('user-id')
				removeItem('refresh-token')
				removeItem('rootState')
				navigate('/'+demoPages.login.path);
				return;
			}		

			if (user.me.type !== 'debriefer' && user.me.type !== 'admin') {							
				if(window.history.length > 0)
					navigate('/' + demoPages.login.path);
				else
					window.location.replace('//' + config.COOKIE_URL === 'localhost' ? config.COOKIE_URL + ':3001' : 'ccp' + config.COOKIE_URL)
				alert('접속 권한이 없습니다.');			
				// removeItem('access-token')
				// removeItem('user-idx')
				// removeItem('refresh-token')
				// removeItem('rootState')	
				// window.location.href = window.location.host.indexOf('localhost') > -1 ? demoPages.login.path : '/exsignon/sso/logout';				
			} 


			// if(user.me?.idx > 0) {
			// 	if(interval) clearInterval(interval)
			// 	interval = setInterval(() => {
			// 		// console.log(moment().format('hh:mm:ss.SSS'))
			// 		loginCheck()
			// 	}, 3000)
			// }
		}
		return () => {
			// if(interval) clearInterval(interval)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	// useEffect(() => {
	// 	// AUTH 확인
		
	// 		// if(withOutAsidePages.findIndex(v => '/' + v === location.pathname) === -1) {
	// 		// 	if(user.me.idx === 0) {
	// 		// 		navigate(demoPages.login.path);		
	// 		// 	}
	// 		// }
	// 		if (!getItem('user-idx')) {
	// 			console.log('user-idx : ' + getItem('user-idx'))
	// 			navigate(demoPages.login.path);
	// 		} else {
	// 			console.log('user-idx : ' + getItem('user-idx'))
	// 			// navigate(homeMenu.intro.path)
	// 		}
	// 	// }
	// 	//eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	useEffect(() => {
		user.authMe().then(() => {
			if(withOutAsidePages.findIndex(v => '/' + v === location.pathname) > -1 || location.pathname === '/' + demoPages.login.path) {
		
				if (user.me.id > 0 && user.me.status === 'SUCCESS') {					
					navigate(homeMenu.intro.path)			
				}
			}	

			if(user.me.id === undefined && location.pathname !== '/' + demoPages.login.path) {
				window.location.href = window.location.host.indexOf('localhost') > -1 ? '/' + demoPages.login.path : '/' + demoPages.login.path;//'/exsignon/sso/logout';
			}
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// useEffect(() => {
	// 	if (user.me.idx === 0 && location.pathname !== '/' + demoPages.login.path) {
	// 		removeItem('access-token')
	// 		removeItem('user-idx')
	// 		removeItem('refresh-token')
	// 		removeItem('rootState')				
	// 		navigate('/'+demoPages.login.path);
	// 		return;
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [user?.me?.idx])

	const loginCheck = useCallback( async () => {
		console.log('loginCheck')
		await user.authMe().then(() => {
			if (!getItem('user-id')) {
				removeItem('access-token')
				removeItem('user-id')
				removeItem('refresh-token')
				removeItem('rootState')
				// location.href = '/exsignon/sso/logout'
				if (window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/exsignon/sso/logout') {					
					alert('다른 브라우저에서 로그인되어 세션이 종료 됩니다.')
					window.location.href = window.location.host.indexOf('localhost') > -1 ? '/' + demoPages.login.path : '/exsignon/sso/logout';
				}
				// navigate(auth.login.path);
			} 
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user])


	//	Add paths to the array that you don't want to be "Aside".
	const withOutAsidePages = [demoPages.login.path, demoPages.signUp.path, layoutMenu.blank.path];

	return (
			<ThemeProvider theme={theme}>
				<ToastProvider components={{ ToastContainer, Toast }}>
					<TourProvider steps={steps} styles={styles} showNavigation={false} showBadge={false}>
						<div
							ref={ref}
							className='app'
							style={{
								backgroundColor: fullScreenStatus && 'var(--bs-body-bg)',
								zIndex: fullScreenStatus && 1,
								overflow: fullScreenStatus && 'scroll',
							}}>
							<Routes>
								{withOutAsidePages.map((path) => (
									<Route key={path} path={path} />
								))}
								<Route path='*' element={<Aside />} />
							</Routes>
							<Wrapper />
						</div>
						<Portal id='portal-notification'>
							<ReactNotifications />
						</Portal>
					</TourProvider>
				</ToastProvider>
			</ThemeProvider>
	);
});

export default App;
